const scrollToBottom = (wait = 0): void => {
  setTimeout(() => {
    if (!document?.scrollingElement) {
      return;
    }
    const scrollingElement = document.scrollingElement || document.body;
    scrollingElement.scrollTop = scrollingElement.scrollHeight;
  }, wait);
};

export default scrollToBottom;
